import { FgEmojiPicker } from './emoji.js';

// Helper functions for caret positioning and pasting HTML
const placeCaretAtEnd = (el) => {
    el.focus();
    if (typeof window.getSelection != "undefined" &&
        typeof document.createRange != "undefined") {
        const range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (typeof document.body.createTextRange != "undefined") {
        const textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
    }
};

const pasteHTMLAtCaret = (html) => {
    let sel, range;
    if (window.getSelection) {
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
            range = sel.getRangeAt(0);
            range.deleteContents();

            const el = document.createElement("div");
            el.innerHTML = html;
            const frag = document.createDocumentFragment();
            let node, lastNode;
            while ((node = el.firstChild)) {
                lastNode = frag.appendChild(node);
            }
            range.insertNode(frag);

            if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    } else if (document.selection && document.selection.type != "Control") {
        document.selection.createRange().pasteHTML(html);
    }
};

// Main initialization function for all emoji handlers
export const initEmojiHandlers = () => {
    // Ensure the emoji object from WordPress is available
    if (typeof emoji_object === 'undefined') {
        console.error('emoji_object is not defined. Make sure it is localized correctly.');
        return;
    }

    // Don't initialize if the trigger is not on the page.
    if (!document.querySelector('#whats-new-form .emojipicker')) {
        return;
    }

    const targetEl = document.querySelector(".advanced-th-bp-activity-form");
    if (!targetEl) {
        console.error('Emoji picker target ".advanced-th-bp-activity-form" not found.');
        return;
    }
    // Main emoji picker for activity post form
    new FgEmojiPicker({
        trigger: ['#whats-new-form .emojipicker'],
        position: ['bottom', 'right'],
        dir: `${emoji_object.sitedir}/`,
        preFetch: true,
        insertInto: targetEl, // Specify target input
    });
};
